module.exports = __webpack_public_path__ + "static/media/post.a60efe63.png";